export default __webpack_public_path__ + "static/media/kda_logo.137a8e26.png";